import { render, staticRenderFns } from "./WVInput.vue?vue&type=template&id=27879f06"
import script from "./WVInput.vue?vue&type=script&lang=js"
export * from "./WVInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports